<template>
  <NewHomepage v-if="showNewHome" />
  <Homepage v-else />
</template>

<script>
import { FlagsHome } from "@/feature-flags/flags-home/index.js";
import Homepage from "@/pages/new-home/Homepage.vue";
import NewHomepage from "@/pages/home/index.vue";
import { isMac, isWindows, isIOS, isAndroid, isLinux } from "@/helpers/getOs";
import { mapActions } from "vuex";

export default {
  components: {
    Homepage,
    NewHomepage,
  },
  computed: {
    showNewHome() {
      if (isMac()) {
        const flagMac = FlagsHome.revamp_enable_mac.isEnabled()
        if (flagMac) this.setShowNewHomeMac(true)
        return flagMac
      }
      if (isWindows()) {
        const flagWindows = FlagsHome.revamp_enable_windows.isEnabled()
        if (flagWindows) this.setShowNewHomeWindows(true)
        return flagWindows
      }
      if (isLinux()) {
        const flagLinux = FlagsHome.revamp_enable_linux.isEnabled()
        if (flagLinux) this.setShowNewHomeLinux(true)
        return flagLinux
      }
      if (isAndroid()) {
        const flagAndroid = FlagsHome.revamp_enable_android.isEnabled()
        if (flagAndroid) this.setShowNewHomeAndroid(true)
        return flagAndroid
      }
      if (isIOS()) {
        const flagIOS = FlagsHome.revamp_enable_ios.isEnabled()
        if (flagIOS) this.setShowNewHomeIOS(true)
        return flagIOS
      }
      return false
    }
  },
  methods: {
    ...mapActions(["setShowNewHomeMac", "setShowNewHomeWindows", "setShowNewHomeLinux", "setShowNewHomeAndroid", "setShowNewHomeIOS"]),
  }
}
</script>
